(function () {
  function getGap(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || '0') || 0;
  }

  function setupCarousel(root) {
    if (!root || root.dataset.tcCarouselReady === 'true') return;

    var track = root.querySelector('.tc-duo-carousel__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tc-duo-carousel__slide'));
    var prev = root.querySelector('.tc-carousel-button--prev');
    var next = root.querySelector('.tc-carousel-button--next');

    if (!track || !slides.length || !prev || !next) return;

    root.dataset.tcCarouselReady = 'true';
    var index = 0;
    var resizeTimer;

    function visibleCount() {
      if (window.matchMedia('(max-width: 749px)').matches) return 1;
      return Number(root.dataset.visible || 2) || 2;
    }

    function maxIndex() {
      return Math.max(0, slides.length - visibleCount());
    }

    function stepSize() {
      var firstSlide = slides[0];
      return firstSlide.getBoundingClientRect().width + getGap(track);
    }

    function update() {
      index = Math.max(0, Math.min(index, maxIndex()));
      track.style.transform = 'translate3d(' + (-index * stepSize()) + 'px, 0, 0)';
      root.dataset.carouselIndex = String(index);
    }

    function move(direction) {
      var step = visibleCount();
      var target = index + (direction * step);
      var max = maxIndex();

      if (target > max) target = 0;
      if (target < 0) target = max;

      index = target;
      update();
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(update, 120);
    });

    update();
  }

  function initCarousels() {
    document.querySelectorAll('.tc-duo-carousel').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  document.addEventListener('shopify:section:load', initCarousels);
})();
